
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/month-actions/[slug]",
      function () {
        return require("private-next-pages/month-actions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/month-actions/[slug]"])
      });
    }
  